import SqlServer from './types/sql-server';

export const sqlNodes = {
  sqlServer: SqlServer,
};
